import React from 'react'

const CenterArrowIco = () => {
    return (
        <div>
            <svg width="61" height="195" viewBox="0 0 61 195" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.99859 0C0.894024 0 -0.00140619 0.895431 -0.00140619 2C-0.00140619 3.10457 0.894024 4 1.99859 4V0ZM20.3086 175.12C20.3086 174.015 18.9558 173.234 17.9992 173.786L2.61799 182.667C1.66141 183.219 1.66141 184.781 2.61799 185.333L17.9992 194.214C18.9558 194.766 20.3086 193.985 20.3086 192.88V175.12ZM1.99859 4H34.9991V0H1.99859V4ZM56.9991 26V160H60.9991V26H56.9991ZM34.9991 182H18.3086V186H34.9991V182ZM56.9991 160C56.9991 172.15 47.1493 182 34.9991 182V186C49.3585 186 60.9991 174.359 60.9991 160H56.9991ZM34.9991 4C47.1493 4 56.9991 13.8497 56.9991 26H60.9991C60.9991 11.6406 49.3585 0 34.9991 0V4Z" fill="#B1B1B1" />
            </svg>

        </div>
    )
}

export default CenterArrowIco
